import { Component, OnInit } from '@angular/core';
import { UserService } from './../../services/user.service';
import { ToastrService } from 'ngx-toastr';
import { Router,ActivatedRoute } from '@angular/router';
import { EncrDecrService } from '../../services/encr-decr.service';

import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment.prod';

class DataTablesResponse {
  data: any[];
  draw: number;
  recordsFiltered: number;
  recordsTotal: number;
}

@Component({
  selector: 'app-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.css']
})
export class UserListComponent implements OnInit {
  public data: any;
  error: string;
  public temp_var: Object=false;
  user_id: any='';
  company_id:any=0;
  APIKEY:any= '';
  statusValue:any='all';
  edit_user_id:any=0;
  user_status:any='';
  on_flag : any='';
  password_new:any='';
  
  constructor( 
    private http:HttpClient,
    private _user:UserService,
    private EncrDecr: EncrDecrService,
    private _router : Router,
    private toastr: ToastrService,private _activatedroute: ActivatedRoute,) { }


  dtOptionsList: DataTables.Settings = {};


  ngOnInit() {
    this.user_id =localStorage.getItem('id');
    this.APIKEY =localStorage.getItem('APIKEY');
    this.company_id =localStorage.getItem('company_id');
    const data={
      APIKEY : this.APIKEY,
      user_id : this.user_id,
      company_id : this.company_id,
      status: ''
    };

    this._activatedroute.params.subscribe(params => {
        this.statusValue = params['status'];
    });

    this.getUserList(data);
  }

  getUserList(requestData){
    this.temp_var=true; 

    requestData['status'] = this.statusValue;

    this.dtOptionsList = {
        pagingType: 'full_numbers',
        pageLength: 100,
        lengthMenu : [25, 50, 100, 150],
        columnDefs: [{
          'targets': [0,8], // column index (start from 0)
          'orderable': false, // set orderable false for selected columns
        }],
        order: [[ 7, 'desc' ]],
        serverSide: true,
        processing: true,
        ajax: (dataTablesParameters: any, callback) => {
          dataTablesParameters.minNumber = dataTablesParameters.start + 1;
          dataTablesParameters.maxNumber = dataTablesParameters.start + dataTablesParameters.length;

          dataTablesParameters.APIKEY = requestData.APIKEY;
          dataTablesParameters.user_id = requestData.user_id;
          dataTablesParameters.company_id = requestData.company_id;
          dataTablesParameters.status = this.statusValue;
          //console.log(dataTablesParameters.minNumber,dataTablesParameters.maxNumber);
          //console.log('All Params', dataTablesParameters);
          this.http
            .post<DataTablesResponse>(
              environment.api+'/User/getUserListByidAjax',
              dataTablesParameters
            )
            .subscribe((resp: any) => {
              
              if(resp.status==true){
                this.data = resp.data;
              } 

              callback({
                recordsTotal: resp.recordsTotal,
                recordsFiltered: resp.recordsFiltered,
                data: []
              });
            });
        },
        columns: [{ data: 'users.id' }, { data: 'users.first_name' }, { data: 'users.last_name' }, { data: 'users.email' }, { data: 'users.phone' }, { data: 'roles.role_name' },  { data: 'users.created_at' }, { data: 'users.u_status' }, { data: 'action' }]
      };

    //this._user.getUserListByid(data)
    //.subscribe(
    //  res => { 
    //    this.data=res;  
    //    this.temp_var=true;  
    //  },
    //); 

  }

  onChangeEvent(ev) {
    const status=  ev.target.value;
    this._router.navigateByUrl('/redirect').then(() => {
      this._router.navigateByUrl('/user/user-list/'+status);
    });
  }

  set_password(customer_id,pass){
    this.edit_user_id = customer_id;
    this.password_new = this.EncrDecr.get(localStorage.getItem('key'), pass);
  }

  /*set_email_user_id(customer_id){  
    this.edit_user_id = customer_id;
    const data_email ={
      c_user_id:this.edit_user_id,
      APIKEY:this.APIKEY,
      email:'',
   }
    
    let password='';
    this._user.getpassword(data_email)
         .subscribe(
           res => { 
             // this.loaderMode=false;
           
             if(res.data!='not_found'){
              
               password = this.EncrDecr.get(localStorage.getItem('key'), res.data);
              
              this.set_password_new(password);
               
            
            }
           },
         ); 
   
  }*/

  send_email_to_user(){
    const data ={
        c_user_id:this.edit_user_id,
        APIKEY:this.APIKEY,
        password_new:this.password_new,
     }

     this._user.sendEmailToUser(data)
      .subscribe(
        res => {
           this.toastr.success(res.message, 'Success');
        },
        err => console.log(err)
      );
  }

  send_sms_to_user(){
    const data ={
        c_user_id:this.edit_user_id,
        APIKEY:this.APIKEY,
        password_new:this.password_new,
    }

    this._user.sendSmsToUser(data)
      .subscribe(
        res => {
          if(res.status==true){
            this.toastr.success(res.message, 'Success');
          } else {
            this.toastr.error(res.message, 'Error');
          }
        },
        err => console.log(err)
      );
  }

  set_active_id(customer_id,status){  
    this.edit_user_id = customer_id;
    this.user_status = status;
  }

  active_customer(){
    const data ={
      c_user_id:this.edit_user_id,
      APIKEY:this.APIKEY,
      user_id:this.user_id,
      status:this.user_status,
    }
 
     this._user.activeuser(data)
      .subscribe(
        res => {
          this.toastr.success(res.message, 'Success');
          this._router.navigateByUrl('/redirect').then(() => {
            this._router.navigate(['/user/user-list/active']);
          });
        },
        err => console.log(err)
      );
  }

  redirectedinto(id)
  {  
    var encrypted = this.EncrDecr.set(localStorage.getItem('key'), id);  
    this._router.navigate(["/user/edit-user/"+encrypted]);
  }
  redirected(id)
  {  
    var encrypted = this.EncrDecr.set(localStorage.getItem('key'), id);  
    this._router.navigate(["/user/view-user/"+encrypted]);
  }

}
